import { render, staticRenderFns } from "./purchases.vue?vue&type=template&id=692e59d1&scoped=true"
import script from "./purchases.vue?vue&type=script&lang=js"
export * from "./purchases.vue?vue&type=script&lang=js"
import style0 from "./purchases.vue?vue&type=style&index=0&id=692e59d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692e59d1",
  null
  
)

export default component.exports